<template>
  <v-dialog v-model="isOpenColophon" fullscreen>
    <div v-if="isDisabled" :class="$style.colophonDisabledArea"></div>

    <div :class="$style.wrapper" data-colophon-area data-colophon-dialog-body>
      <div :class="$style.callout__area" data-description-area>
        <!-- SHARE-1208 吹き出し削除 
        <div
          v-if="!isLoggedIn"
          :class="$style.callout__balloon"
          data-description-balloon
        >
          {{ lang.description }} <br />
          {{ lang.please_login }}
        </div>
        <div v-else :class="$style.callout__balloon" data-description-balloon>
          {{ lang.description }}
        </div>
        -->
      </div>
      <div :class="$style.colophon__area" data-button-area>
        <v-btn
          v-if="!isPanel"
          :class="$style.colophon__button"
          v-on="{ click: returnTop }"
        >
          <span style="white-space: normal">{{ lang.close }}</span>
        </v-btn>
        <v-btn
          v-if="isPanel"
          :class="$style.colophon__button"
          v-on="{ click: returnTop }"
        >
          <span style="white-space: normal">{{ lang.close_panel }}</span>
        </v-btn>
        <template v-if="isShowStar">
          <v-btn
            v-if="!isStar"
            :class="$style.colophon__button"
            v-on="{ click: callAddStar }"
          >
            <span style="white-space: normal">{{ lang.starred }}</span>
          </v-btn>
        </template>
        <template v-if="isShowContentsPage">
          <v-btn
            v-if="!isContentsPage"
            :class="$style.colophon__button"
            v-on="{ click: linkDetailPage }"
          >
            <span style="white-space: normal">{{ lang.detail_page }}</span>
          </v-btn>
        </template>
        <template v-if="isShowLightPlanContentUrls">
          <v-btn
            v-for="(item, index) in lightPlanContentUrlLabels"
            :key="index"
            :class="$style.colophon__button"
            @click="lightPlanUrl(item.url)"
          >
            <span style="white-space: normal"> {{ item.label }} </span>
          </v-btn>
        </template>
        <v-btn
          v-if="displayLinkUrl"
          :class="$style.colophon__navioButton"
          v-on="{ click: navioUrl }"
        >
          <span style="white-space: normal">{{ linkText }}</span>
        </v-btn>
      </div>
    </div>
  </v-dialog>
</template>

<script>
export default {
  name: "vc-share-colophon",
  props: {
    lang: {
      type: Object,
      default: () => {
        return {
          description:
            "お気に入りに追加するとこのようにWALLへ作品を飾って楽しむことができます！",
          please_login:
            "*ご利用にはCLIP STUDIOアカウントでのログインが必要です。",
          close: "もういちど読む",
          close_panel: "もういちど見る",
          starred: "☆お気に入りに追加する",
          detail_page: "詳細ページを表示"
        };
      }
    },
    isLoggedIn: {
      type: Boolean,
      default: false
    },
    linkText: {
      type: String,
      default: ""
    },
    linkUrl: {
      type: String,
      default: ""
    },
    contentUrl: {
      type: String,
      default: ""
    },
    isPreview: {
      type: Boolean,
      default: false
    },
    isStar: {
      type: Boolean,
      default: false
    },
    contentsId: {
      type: Number,
      default: 0
    },
    identificationCode: {
      type: String,
      default: ""
    },
    starredUrl: {
      type: String,
      default: ""
    },
    linkWithTargetBlank: {
      type: Boolean,
      default: false
    },
    isPanel: {
      type: Boolean,
      default: false
    },
    isEmbed: {
      type: Boolean,
      default: false
    },
    isShowStar: {
      type: Boolean,
      default: true
    },
    isShowContentsPage: {
      type: Boolean,
      default: true
    },
    isShowLightPlanContentUrls: {
      type: Boolean,
      default: true
    },
    lightPlanContentUrlLabels: {
      type: Array,
      default: () => {}
    }
  },
  data: function() {
    return {
      contentTop: this.isPreview ? "" : this.contentUrl,
      isStarred: this.isStar,
      isOpenColophon: false,
      openPage: "",
      buttonElementArea: null,
      descriptionElementArea: null,
      isReturn: false,
      displayLinkUrl: this.isPreview ? null : this.linkUrl,
      isDisabled: false,
      isStarting3dViewerComplete: false,
      isStayingOpenColophon: false,
      finishReadingEventObj: null,
      isContentsPage: false
    };
  },
  methods: {
    linkDetailPage: function(ev) {
      ev.stopPropagation();
      if (this.linkWithTargetBlank) {
        window.open(this.contentTop, "_blank");
      } else {
        top.window.location.href = this.contentTop;
      }
    },
    lightPlanUrl: function(url) {
      if (this.linkWithTargetBlank) {
        window.open(url, "_blank");
      } else {
        top.window.location.href = url;
      }
    },
    callAddStar: function(ev) {
      ev.stopPropagation();
      if (this.isPreview) {
        return;
      }

      top.location.href =
        this.starredUrl +
        "?isPostStarred=1&contentsIdentificationCode=" +
        this.identificationCode;
    },
    navioUrl: function(ev) {
      ev.stopPropagation();
      if (this.isPreview) {
        return;
      }
      if (this.linkWithTargetBlank) {
        window.open(this.displayLinkUrl, "_blank");
      } else {
        top.window.location.href = this.displayLinkUrl;
      }
    },
    onClickCloseColophon() {
      if (this.isPreview) {
        return;
      }
      this.isDisabled = true;
      const embeddedViewerIframeElement = document.querySelector(
        "[data-embeded-viewer]"
      ).contentWindow;
      embeddedViewerIframeElement.postMessage(
        { event: "takeOutBooksOnBookshelf", openPage: this.openPage },
        "*"
      );
      this.isOpenColophon = false;
      this.finishReadingEventObj = null;
      this.isStayingOpenColophon = false;
      setTimeout(() => {
        this.isDisabled = false;
      }, 1000);
    },
    hideErrorMessage() {
      setTimeout(() => {
        this.showErrorMessage = false;
      }, 10000);
    },
    returnTop: function(ev) {
      ev.stopPropagation();

      // ハイブリッドビューアv2用
      const hybridIframe = document.querySelector(
        "[data-embeded-hybrid-viewer]"
      );
      if (hybridIframe) {
        hybridIframe.contentWindow.postMessage("first_page", "*");
      }

      this.onClickCloseColophon();
    }
  },
  mounted() {
    this.buttonElementArea = document.querySelector("[data-button-area]");
    this.descriptionElementArea = document.querySelector(
      "[data-description-area]"
    );
    this.descriptionBalloon = document.querySelector(
      "[data-description-balloon]"
    );

    if (!(window === window.parent) && this.isEmbed === false) {
      this.isContentsPage = true;
    }

    window.addEventListener("message", event => {
      const openColophonFunc = event => {
        this.isReturn = false;
        this.isDisabled = true;
        this.openPage =
          event.data.isHalfwayPage === "0" ? "firstPage" : "bookmark";
        // if (event.data.from === "2d") {
        //   window.postMessage({ event: "close2dViewer", isColophon: 1 }, "*");
        // }
        const embeddedViewerIframeElement = document.querySelector(
          "[data-embeded-viewer]"
        ).contentWindow;
        embeddedViewerIframeElement.postMessage(
          {
            event: "putBooksOnBookshelf",
            from: event.data.from,
            isHalfwayPage: event.data.isHalfwayPage
          },
          "*"
        );

        this.isOpenColophon = true;
        this.$nextTick(() => {
          const colophonArea = document.querySelector("[data-colophon-area]");
          colophonArea.addEventListener("click", event => {
            if (
              !this.isReturn &&
              !(this.buttonElementArea === event.target) &&
              !(this.descriptionElementArea === event.target) &&
              !(this.descriptionBalloon === event.target)
            ) {
              this.onClickCloseColophon();
              this.isReturn = true;
            }
          });
        });

        setTimeout(() => {
          this.isDisabled = false;
        }, 1000);
      };

      if (event.data === "starting3dViewerComplete") {
        this.isStarting3dViewerComplete = true;
        if (this.isStayingOpenColophon) {
          openColophonFunc(this.finishReadingEventObj);
        }
      }

      if (event.data.event === "finishReading") {
        if (this.isStayingOpenColophon) {
          return;
        }

        if (this.isStarting3dViewerComplete) {
          openColophonFunc(event);
          return;
        }

        this.isStayingOpenColophon = true;
        this.finishReadingEventObj = event;
      }
    });
  },
  watch: {
    isOpenColophon() {
      if (this.isOpenColophon) {
        this.$nextTick(() => {
          let dialogParentElement = document.querySelector(
            "[data-colophon-dialog-body]"
          ).parentNode.parentNode;
          dialogParentElement.style.zIndex = 25;
        });
      }
    }
  }
};
</script>

<style module lang="scss">
.wrapper {
  width: 100%;
  height: 100%;
  display: flex;
  flex-wrap: wrap;
  align-content: space-between;
  opacity: 0.8;
  line-height: 1em;
}

.colophonDisabledArea {
  position: fixed;
  z-index: 100;
  width: 100%;
  height: 100%;
}

.callout {
  &__area {
    width: 100%;
    height: auto;
    display: flex;
    justify-content: center;
    align-items: center;
  }
  &__balloon {
    position: relative;
    display: inline-block;
    margin: 1.5em 0;
    padding: 7px 10px;
    min-width: 120px;
    max-width: 90%;
    color: #555;
    font-size: 12px;
    background: white;
    border-radius: 20px;
    border: solid lightgray;
    @media screen and (max-height: 420px) {
      margin: 0;
    }
  }
  &__balloon:before {
    content: "";
    position: absolute;
    top: 100%;
    left: 30%;
    margin-left: -15px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 100px 20px 0;
    border-color: transparent lightgrey transparent transparent;
  }
  &__balloon:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 30%;
    margin-top: -4px;
    margin-left: -18px;
    width: 0;
    height: 0;
    border-style: solid;
    border-width: 0 100px 20px 0;
    border-color: transparent white transparent transparent;
  }
}
.colophon {
  &__area {
    width: 100%;
    height: auto;
    min-height: 25%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  &__button {
    text-transform: none !important;
    width: 90%;
    max-width: 400px;
    height: auto;
    border-radius: 24px;
    border-style: solid;
    border-color: #1976d2;
    background-color: cornflowerblue !important;
    color: white !important;
    padding: 6px 24px;
    cursor: pointer;
    font-size: 12px;
  }
  &__navioButton {
    width: 90%;
    max-width: 400px;
    height: auto;
    border-style: solid;
    border-color: #1976d2;
    background-color: cornflowerblue !important;
    color: white !important;
    padding: 6px 24px;
    cursor: pointer;
    font-size: 12px;
  }
}
</style>
